export default "__VITE_ASSET__5DAHc8jK__"